import React from "react";
import { ErrorMessage } from "formik";
import { DatePicker, Input, Tooltip } from "antd";
import { TextError } from "../app/modules/Common/utils";

export function CustomInput({
  field,
  form: { errors, touched },
  label,
  labelStyle,
  suffix,
  prefix,
  withFeedbackLabel = true,
  customFeedbackLabel,
  type = "text",
  autoFocus,
  tooltipContent,
  _type,
  customStyle = false,
  className,
  addOnAfter,
  addOnBefore,
  allowDecimal,
  ...props
}) {
  const params = { ...field, ...props };
  const renderLabel = () => {
    if (!label) return null;

    return (
      <div
        style={{ display: "flex", alignItems: "center", marginBottom: "2px" }}
      >
        <label className={labelStyle ? labelStyle : ""}>{label}</label>
        {/* may be we need to use it after */}
        {/* {tooltipContent && (
          <Tooltip
            overlayStyle={
              customStyle
                ? { maxWidth: "60%", right: "5%", position: "relative" }
                : {}
            }
            trigger={"click"}
            placement="topLeft"
            color={TOOLTIP_BG.color}
            title={
              <p style={{ color: TOOLTIP_BG.textColor }}>{tooltipContent}</p>
            }
          >
            <span style={{ marginLeft: "8px" }}>
              <Icon />
            </span>
          </Tooltip>
        )} */}
      </div>
    );
  };

  const handleWholeNumberChange = (e) => {
    if (/^\d*$/.test(e.target.value)) params.onChange(e);
  };

  return (
    <>
      {label && renderLabel()}
      <div style={{ position: "relative" }}>
        <Input
          type={type}
          style={
            touched[field.name] && errors[field.name]
              ? {
                borderColor: "#f64e60",
                height: "34px",
                marginBottom: "5px",
              }
              : { height: "34px", marginBottom: "5px" }
          }
          prefix={prefix || null}
          className={className}
          addonAfter={addOnAfter}
          addonBefore={addOnBefore}
          onWheel={(e)=>(e.target.blur())}
          {...params}
          onChange={type === "number" && allowDecimal === false ? handleWholeNumberChange : params.onChange}
        />
      </div>
      {withFeedbackLabel && (
        <ErrorMessage name={field.name} component={TextError} />
      )}
    </>
  );
}
